// extracted by mini-css-extract-plugin
export default {"unlisted":"PullRequestStateLabel-module__unlisted--pcrfP"};